import {selector} from 'recoil';
import {UserAccountService} from '../../../../api/services/user-account.service';
import {TypeAccountRoles} from '../../../../shared/types/user-account.types';

export const managerListSelector = selector({
  key: 'managerListStore',
  get: async () => {
    const res = await UserAccountService.getAll({
      spec: {
        roles: [TypeAccountRoles.MANAGER],
        isActive: true,
      },
    });

    return res.data.content;
  },
});
